import { API_BASE_URL } from "../config/apiConfig";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import AuthLayout from "../layouts/AuthLayout";

function ProfessionalRegister() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    profession: "",
    province: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");
    setSuccess("");

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await fetch(
        `${API_BASE_URL}/auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            password: formData.password,
            role: "professional",
            phone: formData.phone,
            profession: formData.profession,
            province: formData.province,
            country: "Canada",
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Registration failed.");
      }

      setSuccess("Account created successfully. Redirecting to login...");

      setTimeout(() => {
        navigate("/professional/login");
      }, 1200);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <AuthLayout
      title="Build your healthcare career with Zeth."
      description="Create your professional profile, upload your credentials and access flexible healthcare assignments."
    >
      <div className="auth-card">
        <p className="account-label">Healthcare professionals</p>
        <h2>Create Professional Account</h2>

        {error && <p className="auth-error">{error}</p>}
        {success && <p className="auth-success">{success}</p>}

        <form
          className="account-form registration-grid"
          onSubmit={handleSubmit}
        >
          <div className="form-field">
            <label htmlFor="first-name">First name</label>
            <input
              id="first-name"
              name="firstName"
              type="text"
              value={formData.firstName}
              onChange={handleChange}
              autoComplete="given-name"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="last-name">Last name</label>
            <input
              id="last-name"
              name="lastName"
              type="text"
              value={formData.lastName}
              onChange={handleChange}
              autoComplete="family-name"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="professional-register-email">
              Email address
            </label>
            <input
              id="professional-register-email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              autoComplete="email"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="professional-phone">Phone number</label>
            <input
              id="professional-phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
              autoComplete="tel"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="profession">Profession</label>
            <select
              id="profession"
              name="profession"
              value={formData.profession}
              onChange={handleChange}
              required
            >
              <option value="">Select profession</option>
              <option value="Registered Nurse">Registered Nurse</option>
              <option value="Registered Practical Nurse">
                Registered Practical Nurse
              </option>
              <option value="Personal Support Worker">
                Personal Support Worker
              </option>
              <option value="Nurse Practitioner">
                Nurse Practitioner
              </option>
              <option value="Respiratory Therapist">
                Respiratory Therapist
              </option>
            </select>
          </div>

          <div className="form-field">
            <label htmlFor="province">Province</label>
            <select
              id="province"
              name="province"
              value={formData.province}
              onChange={handleChange}
              required
            >
              <option value="">Select province</option>
              <option value="Ontario">Ontario</option>
              <option value="Nova Scotia">Nova Scotia</option>
              <option value="New Brunswick">New Brunswick</option>
              <option value="Manitoba">Manitoba</option>
              <option value="Alberta">Alberta</option>
              <option value="British Columbia">
                British Columbia
              </option>
            </select>
          </div>

          <div className="form-field">
            <label htmlFor="professional-register-password">
              Password
            </label>
            <input
              id="professional-register-password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              autoComplete="new-password"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="professional-confirm-password">
              Confirm password
            </label>
            <input
              id="professional-confirm-password"
              name="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              onChange={handleChange}
              autoComplete="new-password"
              required
            />
          </div>

          <button
            className="primary-button registration-submit"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting
              ? "Creating Account..."
              : "Create Professional Account"}
          </button>
        </form>

        <div className="account-links auth-account-links">
          <span>Already registered?</span>
          <Link to="/professional/login">Sign in</Link>
        </div>

        <Link className="return-home-link" to="/">
          ← Return to homepage
        </Link>
      </div>
    </AuthLayout>
  );
}

export default ProfessionalRegister;
